import React from 'react';

import { ListItem } from '@cko/primitives';
import { SideNavMenuItemLink } from '../SideNavMenuItemLink';
import { AvailableGroupMenuItem } from '../../../../providers/NavigationProvider/types';
import { SideNavLabel } from '../SideNavLabel';
import { StyledLevelTwoGroupingContainer, StyledText } from './SideNavLevelTwoGrouping.styles';

type SideNavLevelTwoGroupingProps = {
  menuItemConfig: AvailableGroupMenuItem;
  preventFocus?: boolean;
};

export const SideNavLevelTwoGrouping = ({
  menuItemConfig,
  preventFocus,
}: SideNavLevelTwoGroupingProps) => {
  const { availableChildItems, label, statusLabel } = menuItemConfig;

  return (
    <ListItem>
      <StyledLevelTwoGroupingContainer aria-label={label}>
        <StyledText aria-hidden="true">
          <SideNavLabel label={label} statusLabel={statusLabel} />
        </StyledText>
        {availableChildItems?.map((childItem) => {
          if (childItem.type === 'internal_link') {
            return (
              <SideNavMenuItemLink
                key={childItem.routeId}
                menuItemConfig={childItem}
                level={2}
                preventFocus={preventFocus}
              />
            );
          }

          return null;
        })}
      </StyledLevelTwoGroupingContainer>
    </ListItem>
  );
};
